import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';
class PawstreamEssentials extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.dialog = this.querySelector('dialog');
    this.status = this.querySelector('[role="status"]');
    this.triggers = new Set(this.dataset.triggerIds.split(','));
    this.forms = [...this.querySelectorAll('form')];
    const { signal } = this.controller;
    this.addEventListener('click', event => {
      if (event.target.closest('[data-close]')) this.dialog.close();
    }, { signal });
    this.dialog.addEventListener('click', event => {
      if (event.target !== this.dialog) return;
      const r = this.dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
    }, { signal });
    this.addEventListener('change', event => {
      if (event.target instanceof HTMLSelectElement) event.target.form.querySelector('button [data-price]').textContent = event.target.selectedOptions[0].dataset.price;
    }, { signal });
    this.addEventListener('submit', event => this.addEssential(event), { signal });
    document.addEventListener(StandardEvents.cartLinesUpdate, event => this.onCartAdd(event), { signal });
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
  async getCart() {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  }
  async onCartAdd(event) {
    if (event.action !== 'add' || !event.promise) return;
    try {
      const result = await event.promise;
      if (result.detail?.didError || result.detail?.source === 'pawstream-essentials') return;
      const id = String(result.detail?.productId || '').split('/').pop();
      let cart;
      if (!this.triggers.has(id)) {
        const lines = event.lines || [];
        if (!lines.length) return;
        cart = await this.getCart();
        if (!cart.items.some(item => this.triggers.has(String(item.product_id)) && lines.some(line => String(line.merchandiseId).split('/').pop() === String(item.variant_id)))) return;
      }
      cart ||= await this.getCart();
      const existing = new Set(cart.items.map(item => String(item.product_id)));
      this.forms.forEach(form => {
        form.hidden = existing.has(form.dataset.productId);
        if (!form.hidden && form.dataset.added === 'true') {
          delete form.dataset.added;
          const button = form.querySelector('button[type="submit"]');
          button.disabled = false;
          button.querySelector('[data-add-label]').textContent = button.dataset.originalLabel;
          const select = form.querySelector('select');
          if (select) select.disabled = false;
        }
      });
      if (this.forms.every(form => form.hidden)) return;
      this.status.textContent = '';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (this.isConnected && !this.dialog.open) this.dialog.showModal();
      }));
    } catch {}
  }
  async addEssential(event) {
    event.preventDefault();
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.dataset.busy === 'true' || form.dataset.added === 'true') return;
    const button = form.querySelector('button[type="submit"]');
    const label = button.querySelector('[data-add-label]');
    button.dataset.originalLabel ||= label.textContent;
    form.dataset.busy = 'true';
    button.disabled = true;
    this.status.textContent = '';
    const id = new FormData(form).get('id');
    const deferred = CartLinesUpdateEvent.createPromise();
    deferred.promise.catch(() => {});
    form.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: deferred.promise }));
    let added = false;
    try {
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId))].slice(0, 5);
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections, sections_url: window.location.pathname }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(this.dataset.error);
      added = true;
      form.dataset.added = 'true';
      label.textContent = this.dataset.added;
      const select = form.querySelector('select');
      if (select) select.disabled = true;
      const cart = await this.getCart();
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: data.sections, source: 'pawstream-essentials', productId: form.dataset.productId, didError: false } });
      this.status.textContent = this.dataset.added;
    } catch (error) {
      deferred.reject(error);
      this.status.textContent = added ? this.dataset.addedRefresh : this.dataset.error;
      if (!added) button.disabled = false;
    } finally { delete form.dataset.busy; }
  }
}
if (!customElements.get('pawstream-essentials')) customElements.define('pawstream-essentials', PawstreamEssentials);
